import { render, staticRenderFns } from "./ReportVisit.vue?vue&type=template&id=65f80e52&"
import script from "./ReportVisit.vue?vue&type=script&lang=js&"
export * from "./ReportVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports